export const CHART_OPACITY = {
	ACTIVE: '1',
	INACTIVE: '0.3',
} as const;
